import { BackInStockProductSchema } from "@redotech/redo-model/customer-product-notification/customer-product-notification";
import * as z from "zod/v4";

export const getBackInStockProducts = {
  name: "getBackInStockProducts" as const,
  input: z.object({ searchQuery: z.string().optional() }),
  output: z.object({
    products: z.array(BackInStockProductSchema),
    totalCount: z.number(),
  }),
};
